import { createContext, useState, useCallback } from "react";
import { theme } from "../themes/theme";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

const GlobalContext = createContext();

export const GlobalContextThemeProvider = ({ children }) => {
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [totalOrders, setTotalOrders] = useState(0);
    //snackbar
    const [sbOpen, setSbOpen] = useState(false);
    const [sbMsg, setSbMsg] = useState("");
    const [sbSeverity, setSbSeverity] = useState("info");
    //auth
    const [auth, setAuth] = useState({});

    const sbAlert = useCallback((msg, severity = "info") => {
        setSbOpen(true);
        setSbMsg(msg);
        setSbSeverity(severity);
    }, []);

    return (
        <GlobalContext.Provider
            value={{
                isDarkMode,
                setIsDarkMode,
                isDrawerOpen,
                setIsDrawerOpen,
                sbOpen,
                setSbOpen,
                sbMsg,
                setSbMsg,
                sbSeverity,
                setSbSeverity,
                auth,
                setAuth,
                totalOrders,
                setTotalOrders,
                sbAlert,
            }}
        >
            <ThemeProvider theme={theme(isDarkMode)}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </GlobalContext.Provider>
    );
};

export default GlobalContext;
